"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCompletion = useCompletion;
exports.useStorageState = useStorageState;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _reactUseIdHook = require("react-use-id-hook");

var _CompletedContext = _interopRequireDefault(require("./CompletedContext"));

// ConsumerContext: a context that makes an array of consumers available to its provider.
// WIP (doesn't work yet)

/*export function useConsumerContext2(data) {
  const context = React.createContext([data, {}])

  context.Consumer = ({children}) => {
    if (typeof children !== 'function') {
      throw new Error("ConsumerContext.Consumer: props.children must be a function.")
    }
    const data = useConsumerContext(context)
    return children(data)
  }

  const Provider = context.Provider;
  context.Provider = ({value, children}) => {
    if (typeof children !== 'function') {
      throw new Error("ConsumerContext.Consumer: props.children must be a function.")
    }
    const consumers = React.useState({})
    return <Provider value={[value, consumers]}>
      {children()}
    </Provider>
  }
}

export function useConsumerContext(context) {
  const id = useId();
  const [data, consumers] = React.useContext(context);
  consumers[id] = true;
  React.useEffect(() => {
    consumers[id] = true;
    return () => {
      delete consumers[id];
    }
  })
  return data;
}*/
// useCompletion: communicates with Navigation to provide task completion
function useCompletion(storage, completedDefault) {
  var _useStorageState = useStorageState(storage, "completed", completedDefault),
      _useStorageState2 = (0, _slicedToArray2.default)(_useStorageState, 2),
      completed = _useStorageState2[0],
      setCompleted = _useStorageState2[1];

  var _React$useState = _react.default.useState(),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      taskId = _React$useState2[0],
      setTaskId = _React$useState2[1];

  var context = _react.default.useContext(_CompletedContext.default);

  _react.default.useEffect(function () {
    if (taskId === undefined) {
      context.registerTask(setTaskId);
    }

    context.onCompleted(completed, taskId);
  }, [taskId]);
  /*React.useEffect(()=>{
    context.onCompleted(completed, taskId)
  }, [completed])*/


  return [completed, function (v) {
    if (completed !== v) {
      context.onCompleted(v, taskId);
    }

    setCompleted(v);
  }];
} // useStorageState: stores a value that persists between panels


function useStorageState(storage, id, initialValue) {
  var _React$useState3 = _react.default.useState(initialValue),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      value = _React$useState4[0],
      setValue = _React$useState4[1];

  _react.default.useEffect(function () {
    var _storage$id;

    //console.log("useStorageState useEffect", id, storage[id], "initial", initialValue)
    setValue((_storage$id = storage[id]) !== null && _storage$id !== void 0 ? _storage$id : initialValue);
  }, [storage]);

  return [value, function (v) {
    //console.log("useStorageState setValue", id, storage && storage[id], "v", v)
    storage && (storage[id] = v);
    setValue(v);
  }];
}